<template>
  <div class="projektUebersicht">
    <BaseLevelTableModule
        :headers="headers"
        path="mitarbeiter"
        formComponent="mitarbeiter"
        loading-text="Lade Mitarbeiter ..."
        :scrollable="false"
    >
      <template slot="header">
        <div class="mitarbeiterHeader">
          <v-row>
            <v-col>
              <h2>Mitarbeiter</h2>
            </v-col>
            <v-col cols="auto">
              <b-btn @click="neuenMitarbeiterErstellen()">Mitarbeiter erstellen</b-btn>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:searchFilter>
        <v-text-field
          label="Suche"
          searchKey="suche"
          outlined
          dense
          hideDetails="auto"
          clearable
          style="padding-top: 4px;"
        />
        <b-select
          label="Trägerschaft"
          :items="projekttraegerschaften"
          searchKey="traegerschaft"
          clearable
        />
      </template>
    </BaseLevelTableModule>
  </div>
</template>

<script>
import BaseLevelTableModule from '@/components/base_components/BaseLevelTableModule';
import rollen from '@/utils/data/rollen';
import projekttraegerschaften from '@/utils/data/projekttraegerschaften';

export default {
  name: 'MitarbeiterUebersicht',
  components: {
    BaseLevelTableModule,
  },
  data() {
    return {
      rollen: rollen,
      projekttraegerschaften: projekttraegerschaften,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'Rolle',
          value: 'rolle',
          class: "deep-purple lighten-3 white--text",
          presentWith: this.mapRolle,
        },
        {
          text: 'Nachname',
          value: 'nachname',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Vorname',
          value: 'vorname',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Titel',
          value: 'titel',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'E-Mail',
          value: 'email',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Telefon',
          value: 'telefon',
          class: "deep-purple lighten-3 white--text"
        },
      ]
    }
  },
  methods: {
    mapRolle(val) {
      const mappedRolle = rollen.find((rollen) => rollen.value === val)?.text;
      return mappedRolle != undefined ? mappedRolle : '';
    },
    neuenMitarbeiterErstellen() {
      this.$router.push('/mitarbeiterNeu');
    }
  },
};
</script>

<style scoped lang="scss">

</style>

